import { render, staticRenderFns } from "./LiveSkyPageSettings.vue?vue&type=template&id=c868d914&scoped=true&"
import script from "./LiveSkyPageSettings.vue?vue&type=script&lang=js&"
export * from "./LiveSkyPageSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c868d914",
  null
  
)

export default component.exports